<template>
  <div class="sidebar-overlay" @click="closeSidebar()"></div>
</template>

<script>
export default {
  name: 'overlay',
  data() {
    return {
      mousedown: false,
      dragOffset: 0,
      dragStartX: 0,
      minSwipeDistance: 40,
    };
  },
  mounted() {
    /* istanbul ignore next */
    if ('ontouchstart' in window) {
      this.$el.addEventListener('touchstart', this.handleTouchDown);
      this.$el.addEventListener('touchend', this.handleTouchEnd);
      this.$el.addEventListener('touchmove', this.handleTouchMove);
    }
  },
  methods: {
    closeSidebar() {
      if (window.eventBus) {
        window.eventBus.$emit('sidebar.toggled', false);
        window.eventBus.$emit('sidebarFilter.toggled', false);
        window.eventBus.$emit('update.itemnavigation', false);
        window.eventBus.$emit('update.itemmegamenu', false);
      }
    },
    /* istanbul ignore next */
    handleTouchDown(e) {
      this.mousedown = true;
      this.dragStart = e.touches[0].clientX;
    },
    handleTouchUp() {
      this.mousedown = false;
      this.dragOffset = 0;
    },
    handleTouchMove(e) {
      if (!this.mousedown) {
        return;
      }

      let eventPos = 0;
      let delta = 0;

      /* istanbul ignore next */
      eventPos = e.touches[0].clientX;
      delta = this.dragStart - eventPos;
      this.dragOffset = delta;

      /* istanbul ignore next */
      if (this.dragOffset > this.minSwipeDistance || this.dragOffset > -this.minSwipeDistance) {
        this.handleTouchUp();
        this.closeSidebar();
      }
    },
  },
};
</script>
